(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["component-contact"] && !Shopify.designMode) return;
  try {
    

$('.contact-button').prop("disabled", false);
$('input:checkbox.checks').click(function() {
if ($(this).is(':checked')) {
$('.contact-button').prop("disabled", true);
} else {
if ($('.checks').filter(':checked').length < 1){
$('.contact-button').attr('disabled',false);}
}
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-faq"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function () {
$('.answer').hide();
$('.question-heading').click(function () {
$(this).next().slideToggle(200);
$(this).toggleClass("expanded");

});
$('.answer').slideUp(200);
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Handle anchor scroll buttons
    const anchorScrollBtns = document.querySelectorAll('.anchor-scroll-btn');

    anchorScrollBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();

        const targetSelector = this.getAttribute('data-target');
        if (!targetSelector) return;

        // Find the target element
        let targetElement;

        // Check if it's an ID selector (starts with #)
        if (targetSelector.startsWith('#')) {
          targetElement = document.querySelector(targetSelector);
        }
        // Check if it's a class selector (starts with .)
        else if (targetSelector.startsWith('.')) {
          targetElement = document.querySelector(targetSelector);
        }
        // If no prefix, assume it's an ID
        else {
          targetElement = document.querySelector('#' + targetSelector);
        }

        // If target element exists, scroll to it smoothly
        if (targetElement) {
          const headerHeight = 170;
          const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - headerHeight;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
        } else {
          console.warn('Anchor scroll target not found:', targetSelector);
        }
      });
    });

    // Hero gallery: thumbnail click updates main image and selected state
    document.querySelectorAll('.hero-gallery').forEach(function (gallery) {
      var mainImg = gallery.querySelector('.hero-gallery-main-img');
      var thumbs = gallery.querySelectorAll('.hero-gallery-thumb');
      if (!mainImg || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = this.getAttribute('data-src');
          if (src) {
            mainImg.src = src;
          }
          thumbs.forEach(function (t) {
            t.classList.remove('hero-gallery-thumb-selected');
          });
          this.classList.add('hero-gallery-thumb-selected');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-ui-faq"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function() {
  var answers = document.querySelectorAll('.answer');
  var questionHeadings = document.querySelectorAll('.question-heading');

  for (var i = 0; i < answers.length; i++) {
    answers[i].style.display = 'none';
  }

  for (var i = 0; i < questionHeadings.length; i++) {
    questionHeadings[i].addEventListener('click', function() {
      var answer = this.nextElementSibling;
      answer.style.display = (answer.style.display === 'none') ? 'block' : 'none';
      this.classList.toggle('expanded');
    });
  }

  for (var i = 0; i < answers.length; i++) {
    answers[i].style.display = 'none';
  }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-ui-stylesheet"] && !Shopify.designMode) return;
  try {
    


// Magic ATC

document.addEventListener("DOMContentLoaded",()=>{
    document.querySelectorAll('[data-pf-type="ProductATC"]').forEach(button=>{
        if (button.getAttribute("data-product.available")=="false") {
            button.innerText=button.getAttribute("data-soldout");
            return;
        }
        button.addEventListener("click",(event)=>{
            event.preventDefault();
            doATC(button);
        });
    });
});

function doATC(el) {
    el.innerText = el.getAttribute("data-adding");
    window.fetch("/cart/add.js",{
        method:"POST",
        credentials:"same-origin",
        headers:{
          "content-type":"application/json"
        },
        body:JSON.stringify({
            id:el.getAttribute("data-product-id"),
            quantity:1,
        })
    })
    .then(response=>response.json())
    .then(json=>{
        el.innerText = el.getAttribute("data-added");
        document.dispatchEvent(new CustomEvent(el.getAttribute("data-callback"),{bubbles:true}));
    });
}
  document.addEventListener("atc:gocart",()=>goCart.fetchAndOpenCart());
  document.addEventListener("atc:smartcart",()=>Rebuy.SmartCart.show());
  document.addEventListener("atc:checkout",()=>location.href="/checkout");
  document.addEventListener("atc:cartpage",()=>location.href="/cart");

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    'use strict';
    function equalizeBlockCardsForSection(sectionEl) {
      var sectionId = sectionEl.id;
      if (!sectionId) return;
      var cards = sectionEl.querySelectorAll('.collection-carousel-block');
      if (!cards.length) return;
      var i, h, max = 0;
      for (i = 0; i < cards.length; i++) {
        cards[i].style.minHeight = '';
      }
      document.body.offsetHeight;
      for (i = 0; i < cards.length; i++) {
        h = cards[i].offsetHeight;
        if (h > max) max = h;
      }
      for (i = 0; i < cards.length; i++) {
        cards[i].style.minHeight = max + 'px';
      }
    }
    function runEqualizeAllBlockCards() {
      var sections = document.querySelectorAll('.component-collection-carousel.collection-carousel--block-cards');
      for (var s = 0; s < sections.length; s++) {
        var section = sections[s];
        var slider = section.querySelector('.collection-carousel');
        if (slider && slider.classList.contains('slick-initialized')) {
          equalizeBlockCardsForSection(section);
        }
      }
    }
    var resizeTimer;
    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(runEqualizeAllBlockCards, 150);
    }
    function waitForSlickThenEqualize() {
      var sections = document.querySelectorAll('.component-collection-carousel.collection-carousel--block-cards');
      if (!sections.length) return true;
      var allReady = true;
      for (var s = 0; s < sections.length; s++) {
        var slider = sections[s].querySelector('.collection-carousel');
        if (slider && !slider.classList.contains('slick-initialized')) {
          allReady = false;
          break;
        }
      }
      if (allReady) {
        runEqualizeAllBlockCards();
        return true;
      }
      return false;
    }
    var equalizeAttempts = 0;
    var equalizePoll = setInterval(function() {
      equalizeAttempts++;
      if (waitForSlickThenEqualize() || equalizeAttempts >= 24) {
        clearInterval(equalizePoll);
      }
    }, 250);
    window.addEventListener('resize', onResize);
    if (document.readyState === 'complete') {
      runEqualizeAllBlockCards();
    } else {
      window.addEventListener('load', function() {
        setTimeout(runEqualizeAllBlockCards, 100);
      });
    }
    var jQuery = window.jQuery || window.$;
    if (jQuery && jQuery.fn.slick) {
      jQuery(document).on('init breakpoint', '.collection-carousel', function() {
        var section = this.closest('.component-collection-carousel.collection-carousel--block-cards');
        if (section) {
          setTimeout(function() { equalizeBlockCardsForSection(section); }, 50);
        }
      });
    }
    // Must match collection carousel responsive breakpoints in theme.js
    function getSlidesToScroll() {
      var w = window.innerWidth || document.documentElement.clientWidth || 0;
      if (w > 1024) return 4;
      if (w > 600) return 2;
      return 1;
    }
    function initMobileDashes() {
      var sections = document.querySelectorAll('.component-collection-carousel.carousel-mobile-dashes');
      var jQuery = window.jQuery || window.$;
      if (!jQuery || !jQuery.fn.slick) return false;
      var allDone = true;
      sections.forEach(function(section) {
        var dashesEl = section.querySelector('.carousel-mobile-dashes');
        if (!dashesEl) return;
        var slider = section.querySelector('.collection-carousel');
        if (!slider || !slider.classList.contains('slick-initialized')) {
          allDone = false;
          return;
        }
        var $slider = jQuery(slider);
        if (!$slider.slick) return;
        var slickInstance = $slider.slick('getSlick');
        if (!slickInstance) return;
        var slideCount = slickInstance.slideCount;
        var slidesToScroll = getSlidesToScroll();
        if (slideCount <= 0) return;
        var pageCount = Math.ceil(slideCount / slidesToScroll);
        dashesEl.innerHTML = '';
        for (var i = 0; i < pageCount; i++) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.setAttribute('aria-label', 'Go to page ' + (i + 1));
          btn.classList.add('carousel-mobile-dash');
          if (i === 0) btn.classList.add('active');
          btn.dataset.pageIndex = i;
          dashesEl.appendChild(btn);
        }
        dashesEl.querySelectorAll('.carousel-mobile-dash').forEach(function(btn) {
          btn.addEventListener('click', function() {
            var pageIdx = parseInt(btn.dataset.pageIndex, 10);
            var slideIdx = pageIdx * getSlidesToScroll();
            $slider.slick('slickGoTo', slideIdx);
          });
        });
        $slider.off('afterChange.carouselDashes').on('afterChange.carouselDashes', function(e, slick, currentSlide) {
          var currentPageIndex = Math.floor(currentSlide / getSlidesToScroll());
          dashesEl.querySelectorAll('.carousel-mobile-dash').forEach(function(b, i) {
            b.classList.toggle('active', i === currentPageIndex);
          });
        });
        $slider.off('breakpoint.carouselDashes').on('breakpoint.carouselDashes', function() {
          setTimeout(initMobileDashes, 100);
        });
      });
      return allDone;
    }
    function runWithRetries() {
      var attempts = 0;
      var maxAttempts = 15;
      var interval = setInterval(function() {
        attempts++;
        if (initMobileDashes() || attempts >= maxAttempts) {
          clearInterval(interval);
        }
      }, 250);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runWithRetries);
    } else {
      runWithRetries();
    }
    window.addEventListener('load', function() {
      setTimeout(initMobileDashes, 100);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-component-our-process"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function () {
$('.answer').hide();
$('.question-heading').click(function () {
$(this).next().slideToggle(200);
$(this).toggleClass("expanded");

});
$('.answer').slideUp(200);
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-nav"]) return;
  try {
    
$(document).ready(function () {

    $('.mob-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");

    });
    $('.mobile-child').slideUp(200);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"]) return;
  try {
    

$(document).ready(function () {
    $('.answer').hide();
    $('.question-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.answer').slideUp(200);
});



  } catch(e) { console.error(e); }
})();
})();
